var $2781e73fcde179d5$exports = {};
$2781e73fcde179d5$exports = {
    "info": `Informacja`,
    "negative": `B\u{142}\u{105}d`,
    "notice": `Ostrze\u{17C}enie`,
    "positive": `Powodzenie`
};


export {$2781e73fcde179d5$exports as default};
//# sourceMappingURL=pl-PL.mjs.map
